import { FaArrowRight, FaDollarSign, FaRegClock } from "react-icons/fa";
import { FaArrowTrendUp } from "react-icons/fa6";
import { IoBookOutline } from "react-icons/io5";
import { FiActivity, FiLayout } from "react-icons/fi";
import { PiCellSignalHighBold } from "react-icons/pi";
import { GoPeople } from "react-icons/go";

const cardData = [
    {
        icon: <FaDollarSign />,
        title: "Best-in-class salaries",
        description: "Compensation that reflects your skill and your contribution — reviewed regularly."
    },
    {
        icon: <FaArrowTrendUp />,
        title: "Performance bonus",
        description: "We share our success. Outstanding work is recognised and rewarded."
    },
    {
        icon: <FiLayout />,
        title: "Pension plan",
        description: "We help you plan for the future, not just the present"
    },
    {
        icon: <FiActivity />,
        title: "Health & accident insurance",
        description: "Comprehensive coverage so you can focus on your work without worry."
    },
    {
        icon: <FaRegClock />,
        title: "Regulated working hours",
        description: "We respect your time. Work has a beginning and an end — and we mean it."
    },
    {
        icon: <PiCellSignalHighBold />,
        title: "Clear career trajectory",
        description: "No ambiguity. You will know where you stand and where you can go"
    },
    {
        icon: <IoBookOutline />,
        title: "Ongoing learning",
        description: "Training, mentorship, and development opportunities throughout your time with us."
    },
    {
        icon: <GoPeople />,
        title: "Equal opportunities",
        description: "Talent is what we hire. Nothing else shapes how we evaluate or support our team."
    }
]

const Careers = () => {
    return (
        <div className="w-full min-h-screen bg-black text-white px-5 md:px-10 lg:px-[6vw] py-10 flex flex-col gap-6">


            <div className="flex flex-col gap-6 items-center justify-center">



                {/* Header */}
                <h1 className="text-sm md:text-base tracking-widest text-gray-400">
                    —— TOOTHSKETCH — CAREERS
                </h1>

                <p className="text-lg md:text-xl">Join Our Team</p>

                <h1 className="text-[clamp(28px,4vw,48px)] font-semibold leading-tight">
                    We do <i>meaningful</i> work,<br className="hidden sm:block" /> and we do it together.
                </h1>

                <p className="text-gray-300 max-w-3xl text-center">
                    At Toothsketch, we are building something that matters — precision digital design for dental
                    professionals across the world. We are a team that takes our craft seriously and our people even more so.
                </p>

                {/* Contact */}
                <div className="bg-white/5 border border-gray-800 rounded-xl p-4 md:p-6 max-w-3xl">
                    <p className="text-gray-300 mb-3">
                        If you are interested in working with us, we would love to hear from you. Tell us about your
                        background, what you can contribute, and why you think you would be a strong addition to our team.
                        There is no standard form — just a genuine conversation.
                    </p>

                    <div className="w-fit border-b flex items-center gap-2 border-gray-600 p-1">
                        <a
                            className="font-medium flex items-center gap-2"
                            href="mailto:enquiry@toothsketch.com"
                        >Send us a note
                            <FaArrowRight />
                        </a>
                    </div>
                </div>

                <hr className="border-gray-800" />

                {/* Commitment */}
                <h2 className="text-xl md:text-2xl font-semibold">OUR COMMITMENT TO YOU</h2>

                <h3 className="text-[clamp(22px,3vw,32px)] font-medium">
                    A great career deserves a great place to build it.
                </h3>

                <p className="text-gray-300 max-w-3xl text-center">
                    We invest in the people who power Toothsketch. That means competitive compensation, real career
                    paths, and a workplace that respects your time and your life outside of work. When our people grow, we
                    grow — it is that simple.
                </p>

            </div>

            {/* Cards */}
            <h2 className="text-xl md:text-2xl font-semibold mt-4 text-center">WHAT WE OFFER</h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-5">
                {cardData.map((card, index) => (
                    <div
                        key={index}
                        className="border border-gray-800 rounded-xl p-5 bg-white/5 hover:bg-white/10 transition-all duration-300 flex flex-col gap-3"
                    >
                        {/* Icon */}
                        <div className="text-2xl">
                            {card.icon}
                        </div>

                        {/* Title */}
                        <h3 className="text-lg font-semibold leading-tight">
                            {card.title}
                        </h3>

                        {/* Description */}
                        <p className="text-gray-400 text-sm leading-relaxed">
                            {card.description}
                        </p>
                    </div>
                ))}
            </div>

            {/* Quote */}
            <div className="border-l-4 border-gray-600 pl-4 italic text-gray-300 max-w-4xl">
                "We are proud to be an equal opportunities employer. We do not discriminate on the
                basis of age, gender, background, religion, or caste. Every person at Toothsketch is
                here because of what they bring to the table."
            </div>

            {/* CTA */}
            <h2 className="text-xl md:text-2xl font-semibold mt-4">READY TO CONNECT?</h2>

            <div className="bg-white/5 border border-gray-800 rounded-xl p-4 md:p-6 w-full">
                <p className="text-gray-300 mb-2">
                    We do not always have listed openings — but we are always open to exceptional people. If
                    Toothsketch feels like the right place for you, reach out.
                    Share your background, what you can contribute, and why you think this could be a good fit. We will
                    read every message personally.
                </p>
                <p className="mt-8 mb-2">
                    <a
                        className="font-medium px-4 py-1 rounded-full border border-gray-600"
                        href="mailto:enquiry@toothsketch.com"
                    >
                        enquiry@toothsketch.com
                    </a>
                </p>
            </div>

        </div>
    );
};

export default Careers;